// let stores = [];
//     let map;
//     let markers = [];
//     let activeInfoWindow = null;

//     function initMap() {
//       fetchGoogleSheetData().then(() => {
//         map = new google.maps.Map(document.getElementById("map"), {
//           zoom: 4,
//           center: {
//             lat: 40.8485,
//             lng: -111.917
//           },
//           mapTypeControl: false,
//           streetViewControl: false,
//         });
//         renderStores();
//       });
//     }

//     function fetchGoogleSheetData() {
//       return new Promise((resolve) => {
//         const query = new google.visualization.Query(
//           'https://docs.google.com/spreadsheets/d/1TaDBzGAcJR58FqHRc7W3g8tl4iuRBOzF6MUwyd4Fmco/gviz/tq?sheet=Sheet1'
//         );
//         query.send((response) => {
//           const data = response.getDataTable();
//           const numRows = data.getNumberOfRows();
//           stores = [];
//           for (let i = 0; i < numRows; i++) {
//             stores.push({
//               name: data.getValue(i, 0),
//               address: data.getValue(i, 1),
//               lat: parseFloat(data.getValue(i, 2)),
//               lng: parseFloat(data.getValue(i, 3)),
//               service: data.getValue(i, 4) === true || data.getValue(i, 4) === 'TRUE',
//               phone: data.getValue(i, 5),
//               code: data.getValue(i, 6),
//               image: data.getValue(i, 7),
//               website: data.getValue(i,8)
//             });
//           }
//           resolve();
//         });
//       });
//     }
//     document.getElementById('searchInput').addEventListener('input', function(e) {
//       const searchTerm = e.target.value.toLowerCase().trim();
//       const filteredStores = stores.filter(store =>
//         store.name.toLowerCase().includes(searchTerm) ||
//         store.address.toLowerCase().includes(searchTerm) ||
//         store.code.toLowerCase().includes(searchTerm)
//       );
//       renderStores(filteredStores);
//     });
    
//     document.getElementById('searchInput').addEventListener('keydown', function (e) {
//       if (e.key === 'Enter') {
//         searchLocation();
//       }
//     });


//     function renderStores(filteredStores = stores) {
//       const list = document.getElementById('storeList');
//       document.getElementById('count').innerText = filteredStores.length;
//       list.innerHTML = '';
//       markers.forEach(marker => marker.setMap(null));
//       markers = [];
//       const bounds = new google.maps.LatLngBounds();
//       filteredStores.forEach((store, index) => {
//         const div = document.createElement('div');
//         div.className = 'store-item';
//         div.innerHTML = `
//           <h2> ${store.name}</h2>
//           <p>${store.address}</p>
//           <h4>${formatPhoneNumber(store.phone)} </h4>
//           <div class="buttons">
//             <button class="call-btn">Call Now</button>
//             <button class="directions-btn">Get Directions</button>
//             <button class="website-btn">Go to Site</button>
//           </div>
//         `;
//         list.appendChild(div);
//         div.querySelector('.call-btn').addEventListener('click', () => {
//           window.location.href = `tel:${store.phone}`;
//         });
        
//         div.querySelector('.website-btn').addEventListener('click', () => {
//           window.open(store.website, '_blank');
//         });
//         div.querySelector('.directions-btn').addEventListener('click', () => {
//           const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(store.address)}`;
//           window.open(url, '_blank');
//         });
//         const image = "https://cdn.shopify.com/s/files/1/0861/5883/6028/files/Circle.png?v=1747716863";
//         const marker = new google.maps.Marker({
//           position: {
//             lat: store.lat,
//             lng: store.lng
//           },
//           label: {
//             // text: `${index + 1}`,
//             // text: '',
//             fontWeight: 'bold',
//             fontSize: '16px'
//           },
//           map: map,
//           // icon: image,
//           icon: {
//             url: image,
//             scaledSize: new google.maps.Size(38, 38)
//           }
//         });

//               // <img width="150" class="brand-logo" src="${store.image}" alt=""> <br>
        
//         const infoWindow = new google.maps.InfoWindow({
//           content: `
//             <div style="font-size:14px; font-family:sans-serif; padding: 0px 10px 10px;">
//               <strong>${store.name}</strong><br/>
//               ${store.address}<br/>
//               ${store.service ? '<span style="color:orange; font-size: 12px; margin-top: 11px;">*Service Available</span><br/>' : ''}
//               ${store.phone ? `📞 ${formatPhoneNumber(store.phone)}` : ''} <br>
//               <a style="color: blue;" href="${store.website}"> &#127760; Go to Site<a/>
//             </div>
//           `,
//         });
//         const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

//         if (isTouchDevice) {
//           marker.addListener('click', () => {
//             if (activeInfoWindow) activeInfoWindow.close();
//             infoWindow.open(map, marker);
//             activeInfoWindow = infoWindow;
//           });
//         } else {
//           marker.addListener('click', () => {
//             if (activeInfoWindow) activeInfoWindow.close();
//             infoWindow.open(map, marker);
//             activeInfoWindow = infoWindow;
//           });
//           // marker.addListener('mouseout', () => {
//           //   if (activeInfoWindow) activeInfoWindow.close();
//           //   activeInfoWindow = null;
//           // });
//         }
//         // marker.addListener('mouseover', () => {
//         //   if (activeInfoWindow) activeInfoWindow.close();
//         //   infoWindow.open(map, marker);
//         //   activeInfoWindow = infoWindow;
//         // });
//         // marker.addListener('mouseout', () => {
//         //   if (activeInfoWindow) activeInfoWindow.close();
//         //   activeInfoWindow = null;
//         // });
//         markers.push(marker);
//         bounds.extend(marker.position);
//       });
//       if (filteredStores.length > 0) {
//         map.fitBounds(bounds);
//       }
//     }

// //     function searchLocation() {
// //       const input = document.getElementById('searchInput').value.trim();
// //       if (!input) return;
// //       const geocoder = new google.maps.Geocoder();
// //       geocoder.geocode({
// //         address: input
// //       }, function(results, status) {
// //         if (status === 'OK') {
// //           const location = results[0].geometry.location;
// //           const filteredStores = stores.filter(store => {
// //             const storeLocation = new google.maps.LatLng(store.lat, store.lng);
// //             return google.maps.geometry.spherical.computeDistanceBetween(location, storeLocation) < 804670;

// //           });
// //           renderStores(filteredStores);
// //           map.setCenter(location);
// //           map.setZoom(6);
// //         } else {
// //           alert('Geocode was not successful: ' + status);
// //         }
// //       });
// //     }
    
    
//     function searchLocation() {
//   const input = document.getElementById('searchInput').value.trim();
//   if (!input) return;

//   const geocoder = new google.maps.Geocoder();
//   geocoder.geocode({ address: input }, function(results, status) {
//     if (status !== 'OK') {
//       alert('Geocode was not successful: ' + status);
//       return;
//     }

//     const location = results[0].geometry.location;
//     const isZipCode = /^\d{5}$/.test(input); // Detecta si es ZIP Code exacto
//     const searchRadius = isZipCode ? 16093 : 200000; // 10 millas (ZIP) o 50 millas (ciudad) en metros
//     const zoomLevel = isZipCode ? 12 : 9;

//     const filteredStores = stores.map(store => {
//       const storeLocation = new google.maps.LatLng(store.lat, store.lng);
//       const distance = google.maps.geometry.spherical.computeDistanceBetween(location, storeLocation);
//       return { ...store, distance };
//     }).filter(store => store.distance <= searchRadius);

//     // Opcional: ordena por distancia ascendente
//     filteredStores.sort((a, b) => a.distance - b.distance);

//     renderStores(filteredStores); // Puedes modificar esto para mostrar también la distancia
//     map.setCenter(location);
//     map.setZoom(zoomLevel);
//   });
// }

//     function formatPhoneNumber(phone) {
//   const cleaned = ('' + phone).replace(/\D/g, '');

//   // Si comienza con '1' y tiene 11 dígitos, quitar el '1'
//   const digits = cleaned.length === 11 && cleaned.startsWith('1')
//     ? cleaned.slice(1)
//     : cleaned;

//   // Formato para 10 dígitos
//   const match = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
//   if (match) {
//     return `(${match[1]}) ${match[2]}-${match[3]}`;
//   }

//   return phone; // Devuelve el original si no coincide
// }



    // let stores = [];
    // let map;
    // let markers = [];
    // let activeInfoWindow = null;
    // // Mapa de abreviaturas de estados de EE.UU. (para que la búsqueda por estado
    // // funcione tanto si la dirección dice "UT" como si dice "Utah")
    // const US_STATES = {
    //   'alabama': 'al',
    //   'alaska': 'ak',
    //   'arizona': 'az',
    //   'arkansas': 'ar',
    //   'california': 'ca',
    //   'colorado': 'co',
    //   'connecticut': 'ct',
    //   'delaware': 'de',
    //   'florida': 'fl',
    //   'georgia': 'ga',
    //   'hawaii': 'hi',
    //   'idaho': 'id',
    //   'illinois': 'il',
    //   'indiana': 'in',
    //   'iowa': 'ia',
    //   'kansas': 'ks',
    //   'kentucky': 'ky',
    //   'louisiana': 'la',
    //   'maine': 'me',
    //   'maryland': 'md',
    //   'massachusetts': 'ma',
    //   'michigan': 'mi',
    //   'minnesota': 'mn',
    //   'mississippi': 'ms',
    //   'missouri': 'mo',
    //   'montana': 'mt',
    //   'nebraska': 'ne',
    //   'nevada': 'nv',
    //   'new hampshire': 'nh',
    //   'new jersey': 'nj',
    //   'new mexico': 'nm',
    //   'new york': 'ny',
    //   'north carolina': 'nc',
    //   'north dakota': 'nd',
    //   'ohio': 'oh',
    //   'oklahoma': 'ok',
    //   'oregon': 'or',
    //   'pennsylvania': 'pa',
    //   'rhode island': 'ri',
    //   'south carolina': 'sc',
    //   'south dakota': 'sd',
    //   'tennessee': 'tn',
    //   'texas': 'tx',
    //   'utah': 'ut',
    //   'vermont': 'vt',
    //   'virginia': 'va',
    //   'washington': 'wa',
    //   'west virginia': 'wv',
    //   'wisconsin': 'wi',
    //   'wyoming': 'wy'
    // };

    // function initMap() {
    //   fetchGoogleSheetData().then(() => {
    //     map = new google.maps.Map(document.getElementById("map"), {
    //       zoom: 4,
    //       center: {
    //         lat: 40.8485,
    //         lng: -111.917
    //       },
    //       mapTypeControl: false,
    //       streetViewControl: false,
    //     });
    //     renderStores();
    //   });
    // }

    // function fetchGoogleSheetData() {
    //   return new Promise((resolve) => {
    //     const query = new google.visualization.Query(
    //       'https://docs.google.com/spreadsheets/d/1TaDBzGAcJR58FqHRc7W3g8tl4iuRBOzF6MUwyd4Fmco/gviz/tq?sheet=Sheet1'
    //     );
    //     query.send((response) => {
    //       const data = response.getDataTable();
    //       const numRows = data.getNumberOfRows();
    //       stores = [];
    //       for (let i = 0; i < numRows; i++) {
    //         stores.push({
    //           name: data.getValue(i, 0),
    //           address: data.getValue(i, 1),
    //           lat: parseFloat(data.getValue(i, 2)),
    //           lng: parseFloat(data.getValue(i, 3)),
    //           service: data.getValue(i, 4) === true || data.getValue(i, 4) === 'TRUE',
    //           phone: data.getValue(i, 5),
    //           code: data.getValue(i, 6),
    //           image: data.getValue(i, 7),
    //           website: data.getValue(i, 8)
    //         });
    //       }
    //       resolve();
    //     });
    //   });
    // }
    // // Filtro en vivo mientras se escribe (texto libre)
    // document.getElementById('searchInput').addEventListener('input', function(e) {
    //   const searchTerm = e.target.value.toLowerCase().trim();
    //   if (searchTerm === '') {
    //     renderStores();
    //     return;
    //   }
    //   const filteredStores = stores.filter(store =>
    //     (store.name && store.name.toLowerCase().includes(searchTerm)) ||
    //     (store.address && store.address.toLowerCase().includes(searchTerm)) ||
    //     (store.code && store.code.toLowerCase().includes(searchTerm))
    //   );
    //   renderStores(filteredStores);
    // });
    // document.getElementById('searchInput').addEventListener('keydown', function(e) {
    //   if (e.key === 'Enter') {
    //     searchLocation();
    //   }
    // });

    // function renderStores(filteredStores = stores) {
    //   const list = document.getElementById('storeList');
    //   document.getElementById('count').innerText = filteredStores.length;
    //   list.innerHTML = '';
    //   markers.forEach(marker => marker.setMap(null));
    //   markers = [];
    //   const bounds = new google.maps.LatLngBounds();
    //   filteredStores.forEach((store, index) => {
    //     const div = document.createElement('div');
    //     div.className = 'store-item';
    //     div.innerHTML = `
    //   <h2> ${store.name}</h2>
    //   <p>${store.address}</p>
    //   <h4>${formatPhoneNumber(store.phone)} </h4>
    //   <div class="buttons">
    //     <button class="call-btn">Call Now</button>
    //     <button class="directions-btn">Get Directions</button>
    //     <button class="website-btn">Go to Site</button>
    //   </div>
    // `;
    //     list.appendChild(div);
    //     div.querySelector('.call-btn').addEventListener('click', () => {
    //       window.location.href = `tel:${store.phone}`;
    //     });
    //     div.querySelector('.website-btn').addEventListener('click', () => {
    //       window.open(store.website, '_blank');
    //     });
    //     div.querySelector('.directions-btn').addEventListener('click', () => {
    //       const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(store.address)}`;
    //       window.open(url, '_blank');
    //     });
    //     const image = "https://cdn.shopify.com/s/files/1/0861/5883/6028/files/Circle.png?v=1747716863";
    //     const marker = new google.maps.Marker({
    //       position: {
    //         lat: store.lat,
    //         lng: store.lng
    //       },
    //       label: {
    //         fontWeight: 'bold',
    //         fontSize: '16px'
    //       },
    //       map: map,
    //       icon: {
    //         url: image,
    //         scaledSize: new google.maps.Size(38, 38)
    //       }
    //     });
    //     const infoWindow = new google.maps.InfoWindow({
    //       content: `

    //          <div style="font-size:14px; font-family:sans-serif; padding: 0px 10px 10px;">
    //            <strong>${store.name}</strong><br/>
    //            ${store.address}<br/>
    //            ${store.service ? '<span style="color:orange; font-size: 12px; margin-top: 11px;">*Service Available</span><br/>' : ''}
    //            ${store.phone ? `📞 ${formatPhoneNumber(store.phone)}` : ''} <br>
    //            <a style="color: blue;" href="${store.website}"> &#127760; Go to Site<a/>
    //          </div>

    //   `,
    //     });
    //     marker.addListener('click', () => {
    //       if (activeInfoWindow) activeInfoWindow.close();
    //       infoWindow.open(map, marker);
    //       activeInfoWindow = infoWindow;
    //     });
    //     markers.push(marker);
    //     bounds.extend(marker.position);
    //   });
    //   if (filteredStores.length > 0) {
    //     map.fitBounds(bounds);
    //   }
    // }

    // function searchLocation() {
    //   const input = document.getElementById('searchInput').value.trim();
    //   if (!input) {
    //     renderStores();
    //     return;
    //   }
    //   const geocoder = new google.maps.Geocoder();
    //   geocoder.geocode({
    //     address: input
    //   }, function(results, status) {
    //     if (status !== 'OK') {
    //       alert('Geocode was not successful: ' + status);
    //       return;
    //     }
    //     const result = results[0];
    //     const location = result.geometry.location;
    //     const components = result.address_components;
    //     // Extraer cada componente de la dirección buscada
    //     const getComponent = (type) => {
    //       const comp = components.find(c => c.types.includes(type));
    //       return comp ? comp.long_name.toLowerCase() : null;
    //     };
    //     const country = getComponent('country');
    //     const state = getComponent('administrative_area_level_1');
    //     const city = getComponent('locality') || getComponent('postal_town') ||
    //       getComponent('administrative_area_level_2');
    //     const zip = getComponent('postal_code');
    //     // Tipo de búsqueda
    //     const isZip = /^\d{5}(-\d{4})?$/.test(input);
    //     const isCity = !!city && !isZip;
    //     const isStateOnly = !!state && !city && !isZip;
    //     const isCountryOnly = !!country && !state && !city && !isZip;
    //     let filteredStores;
    //     if (isZip) {
    //       // ZIP: radio de ~10 millas
    //       filteredStores = filterByDistance(location, 16093);
    //       // respaldo si no hay nada cerca
    //       if (filteredStores.length === 0) {
    //         filteredStores = filterByDistance(location, 50000);
    //       }
    //     } else if (isCity) {
    //       // Ciudad: coincidencia de texto + respaldo por distancia
    //       filteredStores = stores.filter(store =>
    //         store.address && city && store.address.toLowerCase().includes(city)
    //       );
    //       if (filteredStores.length === 0) {
    //         filteredStores = filterByDistance(location, 50000); // ~30 millas
    //       }
    //     } else if (isStateOnly) {
    //       // Estado: busca el nombre completo O su abreviatura en la dirección
    //       const stateAbbr = US_STATES[state];
    //       filteredStores = stores.filter(store => {
    //         if (!store.address) return false;
    //         const addr = store.address.toLowerCase();
    //         const matchName = addr.includes(state);
    //         const matchAbbr = stateAbbr &&
    //           new RegExp(`\\b${stateAbbr}\\b`, 'i').test(addr);
    //         return matchName || matchAbbr;
    //       });
    //     } else if (isCountryOnly) {
    //       // País: coincidencia por nombre de país
    //       filteredStores = stores.filter(store =>
    //         store.address && country && store.address.toLowerCase().includes(country)
    //       );
    //     } else {
    //       // Fallback general por distancia
    //       filteredStores = filterByDistance(location, 50000);
    //     }
    //     // Calcular distancia y ordenar de más cercano a más lejano
    //     filteredStores = filteredStores.map(store => {
    //       const storeLoc = new google.maps.LatLng(store.lat, store.lng);
    //       const distance = google.maps.geometry.spherical
    //         .computeDistanceBetween(location, storeLoc);
    //       return {
    //         ...store,
    //         distance
    //       };
    //     }).sort((a, b) => a.distance - b.distance);
    //     renderStores(filteredStores);
    //     if (filteredStores.length === 0) {
    //       map.setCenter(location);
    //       map.setZoom(isZip ? 12 : isCity ? 10 : isStateOnly ? 7 : 5);
    //       alert('No se encontraron retailers en esta área.');
    //     }
    //   });
    // }
    // // Filtra tiendas dentro de un radio (en metros) desde una ubicación
    // function filterByDistance(location, radiusMeters) {
    //   return stores.filter(store => {
    //     const storeLoc = new google.maps.LatLng(store.lat, store.lng);
    //     const distance = google.maps.geometry.spherical
    //       .computeDistanceBetween(location, storeLoc);
    //     return distance <= radiusMeters;
    //   });
    // }

    // function formatPhoneNumber(phone) {
    //   const cleaned = ('' + phone).replace(/\D/g, '');
    //   const digits = cleaned.length === 11 && cleaned.startsWith('1') ?
    //     cleaned.slice(1) :
    //     cleaned;
    //   const match = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
    //   if (match) {
    //     return `(${match[1]}) ${match[2]}-${match[3]}`;
    //   }
    //   return phone;
    // }


    let stores = [];
let map;
let markers = [];
let activeInfoWindow = null;

// Mapa de abreviaturas de estados de EE.UU. (para que la búsqueda por estado
// funcione tanto si la dirección dice "UT" como si dice "Utah")
const US_STATES = {
  'alabama': 'al', 'alaska': 'ak', 'arizona': 'az', 'arkansas': 'ar',
  'california': 'ca', 'colorado': 'co', 'connecticut': 'ct', 'delaware': 'de',
  'florida': 'fl', 'georgia': 'ga', 'hawaii': 'hi', 'idaho': 'id',
  'illinois': 'il', 'indiana': 'in', 'iowa': 'ia', 'kansas': 'ks',
  'kentucky': 'ky', 'louisiana': 'la', 'maine': 'me', 'maryland': 'md',
  'massachusetts': 'ma', 'michigan': 'mi', 'minnesota': 'mn', 'mississippi': 'ms',
  'missouri': 'mo', 'montana': 'mt', 'nebraska': 'ne', 'nevada': 'nv',
  'new hampshire': 'nh', 'new jersey': 'nj', 'new mexico': 'nm', 'new york': 'ny',
  'north carolina': 'nc', 'north dakota': 'nd', 'ohio': 'oh', 'oklahoma': 'ok',
  'oregon': 'or', 'pennsylvania': 'pa', 'rhode island': 'ri', 'south carolina': 'sc',
  'south dakota': 'sd', 'tennessee': 'tn', 'texas': 'tx', 'utah': 'ut',
  'vermont': 'vt', 'virginia': 'va', 'washington': 'wa', 'west virginia': 'wv',
  'wisconsin': 'wi', 'wyoming': 'wy'
};

function initMap() {
  fetchGoogleSheetData().then(() => {
    map = new google.maps.Map(document.getElementById("map"), {
      zoom: 4,
      center: {
        lat: 40.8485,
        lng: -111.917
      },
      mapTypeControl: false,
      streetViewControl: false,
    });
    renderStores();
  });
}

function fetchGoogleSheetData() {
  return new Promise((resolve) => {
    const query = new google.visualization.Query(
      'https://docs.google.com/spreadsheets/d/1TaDBzGAcJR58FqHRc7W3g8tl4iuRBOzF6MUwyd4Fmco/gviz/tq?sheet=Sheet1'
    );
    query.send((response) => {
      const data = response.getDataTable();
      const numRows = data.getNumberOfRows();
      stores = [];
      for (let i = 0; i < numRows; i++) {
        stores.push({
          name: data.getValue(i, 0),
          address: data.getValue(i, 1),
          lat: parseFloat(data.getValue(i, 2)),
          lng: parseFloat(data.getValue(i, 3)),
          service: data.getValue(i, 4) === true || data.getValue(i, 4) === 'TRUE',
          phone: data.getValue(i, 5),
          code: data.getValue(i, 6),
          image: data.getValue(i, 7),
          website: data.getValue(i, 8)
        });
      }
      resolve();
    });
  });
}

// Filtro en vivo mientras se escribe (texto libre)
document.getElementById('searchInput').addEventListener('input', function (e) {
  const searchTerm = e.target.value.toLowerCase().trim();
  if (searchTerm === '') {
    renderStores();
    return;
  }
  const filteredStores = stores.filter(store =>
    (store.name && store.name.toLowerCase().includes(searchTerm)) ||
    (store.address && store.address.toLowerCase().includes(searchTerm)) ||
    (store.code && store.code.toLowerCase().includes(searchTerm))
  );
  renderStores(filteredStores);
});

document.getElementById('searchInput').addEventListener('keydown', function (e) {
  if (e.key === 'Enter') {
    searchLocation();
  }
});

function renderStores(filteredStores = stores) {
  const list = document.getElementById('storeList');
  document.getElementById('count').innerText = filteredStores.length;
  list.innerHTML = '';
  markers.forEach(marker => marker.setMap(null));
  markers = [];
  const bounds = new google.maps.LatLngBounds();

  filteredStores.forEach((store, index) => {
    const div = document.createElement('div');
    div.className = 'store-item';
    div.innerHTML = `
      <h2> ${store.name}</h2>
      <p>${store.address}</p>
      <h4>${formatPhoneNumber(store.phone)} </h4>
      <div class="buttons">
        <button class="call-btn">Call Now</button>
        <button class="directions-btn">Get Directions</button>
        <button class="website-btn">Go to Site</button>
      </div>
    `;
    list.appendChild(div);

    div.querySelector('.call-btn').addEventListener('click', () => {
      window.location.href = `tel:${store.phone}`;
    });
    div.querySelector('.website-btn').addEventListener('click', () => {
      window.open(store.website, '_blank');
    });
    div.querySelector('.directions-btn').addEventListener('click', () => {
      const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(store.address)}`;
      window.open(url, '_blank');
    });

    const image = "https://cdn.shopify.com/s/files/1/0861/5883/6028/files/Circle.png?v=1747716863";
    const marker = new google.maps.Marker({
      position: {
        lat: store.lat,
        lng: store.lng
      },
      label: {
        fontWeight: 'bold',
        fontSize: '16px'
      },
      map: map,
      icon: {
        url: image,
        scaledSize: new google.maps.Size(38, 38)
      }
    });

    const infoWindow = new google.maps.InfoWindow({
      content: `
             <div style="font-size:14px; font-family:sans-serif; padding: 0px 10px 10px;">
               <strong>${store.name}</strong><br/>
               ${store.address}<br/>
               ${store.service ? '<span style="color:orange; font-size: 12px; margin-top: 11px;">*Service Available</span><br/>' : ''}
               ${store.phone ? `📞 ${formatPhoneNumber(store.phone)}` : ''} <br>
               <a style="color: blue;" href="${store.website}"> &#127760; Go to Site<a/>
             </div>
      `,
    });

    marker.addListener('click', () => {
      if (activeInfoWindow) activeInfoWindow.close();
      infoWindow.open(map, marker);
      activeInfoWindow = infoWindow;
    });

    markers.push(marker);
    bounds.extend(marker.position);
  });

  if (filteredStores.length > 0) {
    // Limita el zoom máximo para que no se acerque demasiado
    // (importante cuando solo hay 1 tienda o varias muy cercanas)
    const listener = google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
      if (map.getZoom() > 12) {
        map.setZoom(12);
      }
    });
    map.fitBounds(bounds);
  }
}

function searchLocation() {
  const input = document.getElementById('searchInput').value.trim();
  if (!input) {
    renderStores();
    return;
  }

  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({
    address: input
  }, function (results, status) {
    if (status !== 'OK') {
      alert('Geocode was not successful: ' + status);
      return;
    }

    const result = results[0];
    const location = result.geometry.location;
    const components = result.address_components;

    // Extraer cada componente de la dirección buscada
    const getComponent = (type) => {
      const comp = components.find(c => c.types.includes(type));
      return comp ? comp.long_name.toLowerCase() : null;
    };

    const country = getComponent('country');
    const state = getComponent('administrative_area_level_1');
    const city = getComponent('locality') || getComponent('postal_town') ||
      getComponent('administrative_area_level_2');
    const zip = getComponent('postal_code');

    // Tipo de búsqueda
    const isZip = /^\d{5}(-\d{4})?$/.test(input);
    const isCity = !!city && !isZip;
    const isStateOnly = !!state && !city && !isZip;
    const isCountryOnly = !!country && !state && !city && !isZip;

    let filteredStores;

    if (isZip) {
      // ZIP: radio de ~10 millas
      filteredStores = filterByDistance(location, 16093);
      // respaldo si no hay nada cerca
      if (filteredStores.length === 0) {
        filteredStores = filterByDistance(location, 50000);
      }
    } else if (isCity) {
      // Ciudad: coincidencia de texto + respaldo por distancia
      filteredStores = stores.filter(store =>
        store.address && city && store.address.toLowerCase().includes(city)
      );
      if (filteredStores.length === 0) {
        filteredStores = filterByDistance(location, 50000); // ~30 millas
      }
    } else if (isStateOnly) {
      // Estado: busca el nombre completo O su abreviatura en la dirección
      const stateAbbr = US_STATES[state];
      filteredStores = stores.filter(store => {
        if (!store.address) return false;
        const addr = store.address.toLowerCase();
        const matchName = addr.includes(state);
        const matchAbbr = stateAbbr &&
          new RegExp(`\\b${stateAbbr}\\b`, 'i').test(addr);
        return matchName || matchAbbr;
      });
    } else if (isCountryOnly) {
      // País: coincidencia por nombre de país
      filteredStores = stores.filter(store =>
        store.address && country && store.address.toLowerCase().includes(country)
      );
    } else {
      // Fallback general por distancia
      filteredStores = filterByDistance(location, 50000);
    }

    // Calcular distancia y ordenar de más cercano a más lejano
    filteredStores = filteredStores.map(store => {
      const storeLoc = new google.maps.LatLng(store.lat, store.lng);
      const distance = google.maps.geometry.spherical
        .computeDistanceBetween(location, storeLoc);
      return {
        ...store,
        distance
      };
    }).sort((a, b) => a.distance - b.distance);

    renderStores(filteredStores);

    if (filteredStores.length === 0) {
      map.setCenter(location);
      map.setZoom(isZip ? 12 : isCity ? 10 : isStateOnly ? 7 : 5);
      alert('No se encontraron retailers en esta área.');
    }
  });
}

// Filtra tiendas dentro de un radio (en metros) desde una ubicación
function filterByDistance(location, radiusMeters) {
  return stores.filter(store => {
    const storeLoc = new google.maps.LatLng(store.lat, store.lng);
    const distance = google.maps.geometry.spherical
      .computeDistanceBetween(location, storeLoc);
    return distance <= radiusMeters;
  });
}

function formatPhoneNumber(phone) {
  const cleaned = ('' + phone).replace(/\D/g, '');
  const digits = cleaned.length === 11 && cleaned.startsWith('1') ?
    cleaned.slice(1) :
    cleaned;
  const match = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phone;
}